import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
                <span className="inline-block px-3 py-1 text-xs font-semibold bg-background-50/20 text-background-50 rounded-full whitespace-nowrap mb-4">
                  移动端专属
                </span>
                <h2 className="text-2xl md:text-3xl font-heading text-background-50">
                  {appData.title}
                </h2>
                <p className="mt-2 text-lg text-background-50/90 font-medium">
                  {appData.subtitle}
                </p>
                <p className="mt-4 text-sm text-background-50/80 leading-relaxed max-w-lg mx-auto lg:mx-0">
                  {appData.desc}
                </p>

                <ul className="mt-6 grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0">
                  {appData.features.map((feat, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-background-50/90">
                      <i className="ri-checkbox-circle-fill text-accent-300 text-base"></i>
                      <span className="whitespace-nowrap">{feat}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <span className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-semibold text-sm rounded-full hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    <i className="ri-apple-fill text-lg"></i>
                    iOS 下载
                  </span>
                  <span className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 font-medium text-sm rounded-full border border-background-50/30 hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    <i className="ri-android-fill text-lg"></i>
                    Android 下载
                  </span>
                </div>
              </div>

              <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-0">
                <div className="relative w-64 h-[420px] rounded-2xl overflow-hidden bg-background-50/10">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20mobile%20phone%20mockup%20showing%20a%20manga%20reading%20app%20interface%20with%20colorful%20comic%20thumbnails%20on%20screen%2C%20warm%20cream%20and%20coral%20accents%2C%20minimal%20UI%20design%2C%20floating%20phone%20on%20soft%20gradient%20background%2C%20product%20showcase%20style%2C%20high%20quality&width=512&height=840&seq=app-mockup&orientation=portrait"
                    alt="丫丫漫画APP界面预览"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}